/**
 * @fileoverview Settings route configuration
 * Handles password changes, user profile settings
 */

// Third-party imports
import { createFileRoute, Navigate } from "@tanstack/react-router";

// Page components
import AdministrationPage from "@/features/dashboard/pages/administration";
import { isOperatorUser } from "@/features/dashboard/lib/access-control";
import { useAuth } from "@/providers/auth.provider";
import { AppErrorBoundary } from "@/components/shared/app-error-boundary";

/**
 * Settings landing. Tuzidi operators see internal Administration (RBAC/policy);
 * client users are routed to their own account settings - operator content is never shown to clients.
 */
function SettingsIndex() {
  const { claims } = useAuth();

  if (!isOperatorUser(claims)) {
    return <Navigate to="/dashboard/settings/user-profile" replace />;
  }

  return (
    <main role="main" aria-label="Administration" className="min-h-screen w-full">
      <AdministrationPage />
    </main>
  );
}

/**
 * Route configuration for the  settings page
 * Uses TanStack Router's file-based routing system
 */
export const Route = createFileRoute("/(app)/dashboard/settings/")({
  component: SettingsIndex,
  errorComponent: AppErrorBoundary,
});
